(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ze-product-video"] && !Shopify.designMode) return;
  try {
    

class ZEProductVideos extends HTMLElement {

constructor() {
  super();

  this.videoCards = this.querySelectorAll('.ze-product-video-card');

  this.initVideos();

  if (this.dataset.videoCount > 1) {
    this.initSlider();
  }
}


initVideos() {

  this.videoCards.forEach((card) => {

    const video = card.querySelector('video');

    const button = card.querySelector('.ze-product-video-btn-play');

    if (!video || !button) return;


    button.addEventListener('click', (event) => {

      event.preventDefault();

      this.toggleVideo(card, video);

    });


    video.addEventListener('click', () => {

      this.toggleVideo(card, video);

    });

  });

}


toggleVideo(card, video) {

  const isPlaying = card.dataset.playing === 'true';

  /* ترتيب عالمي: يوقف كل الفيديوهات بالصفحة، بغض النظر عن السكشن اللي هي فيه */
  document.querySelectorAll('.ze-product-video-card').forEach((otherCard) => {

    if (otherCard !== card) {

      otherCard.dataset.playing = 'false';

      const otherVideo = otherCard.querySelector('video');

      if (otherVideo) {

        otherVideo.pause();

      }

    }

  });


  if (isPlaying) {

    card.dataset.playing = 'false';

    video.pause();

  } else {

    card.dataset.playing = 'true';

    video.muted = false;

    video.play();

  }

}


initSlider() {

  const initSwiper = () => {

    if (!window.Swiper) {

      setTimeout(initSwiper, 100);

      return;

    }


    const swiperElement = this.querySelector('.swiper');

    if (!swiperElement) return;


    this.slider = new window.Swiper(swiperElement, {

      slidesPerView: 1.15,

      centeredSlides: true,

      spaceBetween: 12,

      speed: 400,

      loop: false,

      watchSlidesProgress: true,

      navigation: false,

      pagination: {

        el: this.querySelector('.swiper-pagination'),

        clickable: true,

      },

      breakpoints: {

        750: {

          slidesPerView: 2,

          centeredSlides: true,

          spaceBetween: 20

        },

        1200: {

          slidesPerView: 2,

          centeredSlides: true,

          spaceBetween: 24

        }

      }

    });


    swiperElement.classList.add('swiper-initialized');


    this.slider.on('slideChange', () => {

      /* ترتيب عالمي هنا أيضًا: تغيير الشريحة بأي سكشن يوقف فيديوهات كل الصفحة */
      document.querySelectorAll('.ze-product-video-card').forEach((card) => {

        card.dataset.playing = 'false';

        card.querySelector('video')?.pause();

      });

    });

  };


  if (!document.querySelector('#ze-product-videos-swiper-css')) {

    const stylesheet = document.createElement('link');

    stylesheet.id = 'ze-product-videos-swiper-css';

    stylesheet.rel = 'stylesheet';

    stylesheet.href = 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.css';

    document.head.appendChild(stylesheet);

  }


  if (!document.querySelector('#ze-product-videos-swiper-js')) {

    const script = document.createElement('script');

    script.id = 'ze-product-videos-swiper-js';

    script.src = 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.js';

    script.onload = initSwiper;

    document.head.appendChild(script);

  } else {

    initSwiper();

  }

}

}

if (!customElements.get('ze-product-videos')) {

customElements.define('ze-product-videos', ZEProductVideos);

}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ze-shoppable-videos"] && !Shopify.designMode) return;
  try {
    
  class ZeShoppableVideos extends HTMLElement {
    constructor() {
      super();

      if (!document.querySelector('#swiper-stylesheet')) {
        const stylesheet = document.createElement('link');
        stylesheet.setAttribute('href', 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.css');
        stylesheet.setAttribute('rel', 'stylesheet');
        stylesheet.setAttribute('id', 'swiper-stylesheet');
        stylesheet.setAttribute('integrity', 'sha256-5nkrwjVsiNfKz3NR1k2h5+qt5pS5SF2u9/TIT1hElow=');
        stylesheet.setAttribute('crossorigin', 'anonymous');
        document.head.appendChild(stylesheet);
      }

      if (!document.querySelector('#swiper-script')) {
        const script = document.createElement('script');
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.js');
        script.setAttribute('id', 'swiper-script');
        script.setAttribute('integrity', 'sha256-rCACDWCp/VzIh0rsB+ipQCM9XBvO8HNe0fNSOa4sys0=');
        script.setAttribute('crossorigin', 'anonymous');
        document.head.appendChild(script);
      }

      setTimeout(() => {
        const slider = new window.Swiper(this.querySelector('.swiper'), this.sliderOptions());

        slider.on('slideChange', () => {
          this.querySelector('.swiper').classList.add('swiper-is-changing');
          this.onSlideChange();
        });

        slider.on('slideChangeTransitionEnd', () => {
          this.querySelector('.swiper').classList.remove('swiper-is-changing');
        });
      }, 500);

      this.querySelectorAll('.ze-shoppable-videos-btn-play').forEach((btn) => {
        btn.addEventListener('click', () => {
          const video = btn.closest('.ze-shoppable-videos-video-wrapper').querySelector('video');
          this.onVideoPlay(video);
        });
      });

      this.querySelectorAll('video').forEach((video) => {
        video.addEventListener('click', () => {
          this.onVideoPlay(video);
        });
      });

      const lazyVideosObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.play();
          }
        });
      }, { rootMargin: '0px 0px 300px 0px' });

      this.querySelectorAll('video[data-autoplay="true"]').forEach((el) => {
        lazyVideosObserver.observe(el);
      });
    }

    sliderOptions() {
      const partialSlidesMobile = this.dataset.partialSlidesMobile === 'true' ? 1.2 : 1;

      return {
        rewind: true,
        speed: Number(this.dataset.sliderSpeed),
        breakpoints: {
          0: { slidesPerView: Number(this.dataset.breakpointXs) * partialSlidesMobile },
          576: { slidesPerView: Number(this.dataset.breakpointSm) },
          768: { slidesPerView: Number(this.dataset.breakpointMd) },
          992: { slidesPerView: Number(this.dataset.breakpointLg) },
          1200: { slidesPerView: Number(this.dataset.breakpointXl) },
          1400: { slidesPerView: Number(this.dataset.breakpointXxl) }
        },
        navigation: {
          enabled: this.dataset.sliderNav === 'true',
          nextEl: this.querySelector('.swiper-button-next'),
          prevEl: this.querySelector('.swiper-button-prev')
        },
        pagination: {
          enabled: this.dataset.sliderPagination === 'true',
          type: this.dataset.sliderPaginationType,
          el: this.querySelector('.swiper-pagination'),
          dynamicBullets: true,
          dynamicMainBullets: 2,
          renderFraction: function(currentClass, totalClass) {
            return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`;
          }
        },
        scrollbar: {
          enabled: this.dataset.sliderScrollbar === 'true',
          el: this.querySelector('.swiper-scrollbar'),
          draggable: true
        },
        autoplay: this.dataset.sliderAutoplay !== '0'
          ? { delay: Number(this.dataset.sliderAutoplay) * 1000 }
          : undefined,
        watchSlidesProgress: true,
        mousewheel: {
          enabled: true,
          forceToAxis: true
        }
      };
    }

    onSlideChange() {
      /* ترتيب عالمي: يوقف كل فيديوهات الصفحة عند تغيير الشريحة، مو بس داخل نفس السكشن */
      document.querySelectorAll('.ze-shoppable-videos-card').forEach((elem) => {
        elem.setAttribute('data-is-playing', 'false');
        elem.querySelector('video')?.pause();
      });
    }

    onVideoPlay(video) {
      const card = video.closest('.ze-shoppable-videos-card');

      /* ترتيب عالمي: يوقف كل فيديوهات الصفحة، حتى لو كانت بسكشن ثاني */
      document.querySelectorAll('.ze-shoppable-videos-card').forEach((elem) => {
        if (elem !== card) {
          elem.setAttribute('data-is-playing', 'false');
          elem.querySelector('video')?.pause();
        }
      });

      if (card.dataset.isPlaying === 'true') {
        card.setAttribute('data-is-playing', 'false');
        video.pause();
      } else {
        card.setAttribute('data-is-playing', 'true');
        video.muted = false;
        video.play();
      }
    }
  }

  customElements.define('ze-shoppable-videos', ZeShoppableVideos);

  } catch(e) { console.error(e); }
})();
})();
